/* eslint-disable @reatom/unit-naming-rule */
import { atom, withInit } from '@reatom/framework'

import { CurrencyModel } from '@root/entities/currency'

import type { WalletAssetModel, WalletModel } from '@root/entities/wallet'

export const reatomManageHiddenAssets = ({
  wallet,
}: {
  wallet: WalletModel
}) => {
  // We keep as stateful atom to preserve initially hidden assets
  const initiallyHiddenAssetsAtom = atom<Array<WalletAssetModel>>([]).pipe(
    withInit((ctx) => {
      const allAssets = ctx.get(wallet.assets)
      return allAssets.filter((it) => ctx.get(it.hidden))
    }),
  )

  const searchQueryAtom = atom('')

  const assetsAtom = atom((ctx) => {
    const query = ctx.spy(searchQueryAtom).trim()
    const assets = ctx.spy(initiallyHiddenAssetsAtom)
    if (!query) {
      return assets
    }
    return assets.filter((it) => CurrencyModel.match(query)(it.currency))
  })

  return {
    assets: assetsAtom,
    searchQuery: searchQueryAtom,
  }
}
